<div class="phone-container">
  <div class="text-content">
    <h3>Enter Mobile Number</h3>
    <p>We need your phone number to verify your identity.</p>
  </div>

  <div class="input-group">
    <div class="country-selector">
      <ion-select interface="action-sheet" [(ngModel)]="selectedCountry" class="country-select"
        [interfaceOptions]="{header: 'Select Country'}" toggle-icon="chevron-down-outline">
        <ion-select-option *ngFor="let country of countryService.countries" [value]="country">
          {{country.flag}} {{country.name}} ({{country.code}})
        </ion-select-option>
      </ion-select>
      <div class="selected-display">
        <span class="flag">{{selectedCountry.flag}}</span>
        <span class="code">{{selectedCountry.code}}</span>
      </div>
    </div>
    <input id="login_page_mobile_input" type="tel" class="modern-input" placeholder="Mobile Number" [(ngModel)]="phoneNumber"
      (input)="onPhoneNumberChange()" maxlength="15">
  </div>
  <div class="nameWrapping">
    <input id="login_page_name_input" class="phone__input" type="name" placeholder="Enter Your Name" [(ngModel)]="name" />
  </div>

  <ion-button id="login_page_get_verification_code_button" expand="block" shape="round" class="action-btn" (click)="sendOTP()"
    [disabled]="phoneNumber.length < 5 || name.length===0">
    <span>Get Verification Code</span>
  </ion-button>

  <div id="recaptcha-container"></div>
</div>